"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userScopes = void 0;

var _immutable = require("immutable");

var _once = _interopRequireDefault(require("transmute/once"));

var _userInfo = _interopRequireDefault(require("hub-http/userInfo"));

var userScopes = (0, _once.default)(function () {
  return (0, _userInfo.default)().then(function (_ref) {
    var scopes = _ref.user.scopes;
    return (0, _immutable.Set)(scopes);
  });
});
exports.userScopes = userScopes;